export const camelToKebab = (value) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();

export const createDisplayImageField = (id, label, overrides = {}) => {
  const kebab = camelToKebab(id);

  return {
    id,
    label,
    uriKey: `${id}Uri`,
    uploadTestId: `${kebab}-upload`,
    validationErrorTestId: `${kebab}-validation-error`,
    ...overrides
  };
};
